<template>
  <div>
    <el-table :data="dataList" border style="width: 100%">
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
        label="行号"
      ></el-table-column>
      <el-table-column
        prop="agreementCode"
        label="外销合同编号"
        header-align="center"
        align="center"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="productName"
        label="品名"
        header-align="center"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="color"
        label="颜色"
        header-align="center"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="size"
        label="规格"
        header-align="center"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="attr1"
        label="幅宽"
        header-align="center"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="attr2"
        label="克重"
        header-align="center"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column prop="amount" label="单价" header-align="center" align="center"></el-table-column>
      <el-table-column
          prop="count"
          label="计划数"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="completeCount"
          label="收货数"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column prop="realPrice" label="开票单价" header-align="center" align="center"></el-table-column>
      <el-table-column
        prop="companyName"
        label="供应商"
        header-align="center"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        label="收货仓库"
        header-align="center"
        align="center"
        prop="storageName"
        min-width="120"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import BigNumber from 'bignumber.js'
export default {
  name: "order-purchase",
  mixins: [mixinViewModule],
  components: {},
  props: {
    agreementId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/purchase/page",
        getDataListIsPage: true,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: "",
      },
    };
  },
  watch: {
    agreementId: {
      handler: function(newVal) {
        if (newVal && newVal !== "") {
          this.dataForm.agreementId = newVal;
          this.getDataList();
        } else {
          this.dataList = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeTableBinding(dataList){
      dataList.forEach(row=>{
        row.totalAmount=new BigNumber(row.count).multipliedBy(row.amount).toFixed(2)
        row.realPrice=0
        if(row.completeCount<=0){
          return
        }
        if(row.realTotalPrice<=0){
          return
        }
        row.realPrice=new BigNumber(row.realTotalPrice).dividedBy(row.completeCount).toFixed(2)
      })
    }
  },
};
</script>
